var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileDetectedDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 121,
    viewBox: "0 0 280 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.192 9.90488H210.269C193.936 9.90488 185.77 9.90488 179.981 13.9353C177.839 15.4263 175.976 17.2786 174.477 19.4082C170.423 25.1641 170.423 33.2842 170.423 49.5243C170.423 65.7644 170.423 73.8844 174.477 79.6406C175.976 81.7701 177.839 83.6223 179.981 85.1135C185.77 89.1438 193.936 89.1438 210.269 89.1438H230.192C246.525 89.1438 254.692 89.1438 260.481 85.1135C262.623 83.6223 264.485 81.7701 265.985 79.6406C270.038 73.8844 270.038 65.7644 270.038 49.5243C270.038 33.2842 270.038 25.1641 265.985 19.4082C264.485 17.2786 262.623 15.4263 260.481 13.9353C254.692 9.90488 246.525 9.90488 230.192 9.90488Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.25 74.2865H225.212",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M232.683 108.954L231.111 106.879C227.569 102.203 226.69 95.059 228.931 89.1438M207.779 108.954L209.35 106.879C212.893 102.203 213.771 95.059 211.53 89.1438",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M195.327 108.954H245.135",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.949 82.8529V50.729C150.949 43.1573 150.949 39.3715 148.609 37.0193C146.27 34.6671 142.505 34.6671 134.974 34.6671H103.026C95.4952 34.6671 91.73 34.6671 89.3907 37.0193C87.0513 39.3715 87.0513 43.1573 87.0513 50.729V82.8529"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.949 82.8529V50.729C150.949 43.1573 150.949 39.3715 148.609 37.0193C146.27 34.6671 142.505 34.6671 134.974 34.6671H103.026C95.4952 34.6671 91.73 34.6671 89.3907 37.0193C87.0513 39.3715 87.0513 43.1573 87.0513 50.729V82.8529",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119 46.7135H119.035",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.045 86.9302L87.1293 82.8529H150.756L152.955 86.9302C158.717 97.6178 160.152 102.961 157.962 106.961C155.772 110.961 149.965 110.961 138.351 110.961H99.6495C88.0354 110.961 82.2282 110.961 80.038 106.961C77.8478 102.961 79.2827 97.6178 85.045 86.9302Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9423 50.9521H28.1346C19.7581 50.9521 15.5698 50.9521 12.9676 53.5787C10.3654 56.2053 10.3654 60.4329 10.3654 68.8879V92.8024C10.3654 101.257 10.3654 105.485 12.9676 108.111C15.5698 110.738 19.7581 110.738 28.1346 110.738H42.9423C51.3187 110.738 55.5069 110.738 58.1092 108.111C60.7115 105.485 60.7115 101.257 60.7115 92.8024V68.8879C60.7115 60.4329 60.7115 56.2053 58.1092 53.5787C55.5069 50.9521 51.3187 50.9521 42.9423 50.9521Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6154 58.4253H41.4615",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5378 101.77H35.567",
    stroke: "#CCCCCC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDetectedDark);
export default __webpack_public_path__ + "static/media/mobile-detected-dark.34b6d151374ed016ed3b02be24101218.svg";
export { ForwardRef as ReactComponent };